export const doctorsListPage = "/our-doctors";
